<template>
	<div class="input__wrapper">
		<label class="range-input">
			<span class="input-label" :id="data.labelId">{{ data.label }}</span>
			<div class="range-input__wrap">
				<span :class="data.classIcon">
					<SvgIcon
						class="dolar-icon"
						:iconName="data.iconName"
					/>
				</span>
				<div class='range-slider'>
					<PartInputFormatedNum v-model="values.min" :data="rangeDataMin" :currency="data.currency" v-debounce:500="triggerKeys" :isDisabled="isDisabled"/>
					<PartInputFormatedNum v-model="values.max" :data="rangeDataMax" :currency="data.currency" v-debounce:500="triggerKeys" :isDisabled="isDisabled"/>
				</div>
			</div>
		</label>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartInputFormatedNum from '@/components/parts/PartInputFormatedNum';
export default {
	components: {
		SvgIcon,
		PartInputFormatedNum
	},
	props: {
		data: {
			type: Object,
			required: true
		},
		obj: {
			type: Object
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			values: {
				min: '',
				max: ''
			},
			rangeDataMin: {
				onlyInputs: true,
				placeholder: 'Min'
			},
			rangeDataMax: {
				onlyInputs: true,
				placeholder: 'Max'
			}
		};
	},
	watch: {
		obj() {
			this.values = this.obj;
		}
	},
	methods: {
		triggerKeys() {
			this.$emit('valueFromChild', this.values, this.data.flag);
		}
	}
};
</script>

<style lang="scss" scoped>
.range-input {
	width: fit-content;

	@include mq($sm) {
		width: 100%;
	}
}

.range-input__wrap {
	display: flex;

	input {
		max-width: 122px;

		&:first-of-type {
			border-right: 0;
			transition: $dur $ease;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}
	}
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.range-slider {
	display: flex;

	@include mq($sm) {
		width: 100%;
	}

	div {
		position: relative;
		
		&:first-of-type {
			&::after {
				content: '';
				background-color: $pale-sky;
				position: absolute;
				height: calc(100% - 28px);
				top: 50%;
				transform: translateY(-50%);
				right: 0;
				width: 1px;
				z-index: 1;
				opacity: 0.5;
			}
		}
	}

	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 18px 9px 13px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;

		@include mq($sm) {
			font-size: 16px;
			max-width: 100%;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

input[type=number] {
	-moz-appearance: textfield;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.input-icon-box {
    background-color: $white-lilac;
	min-height: 46px;
    min-width: 47px;
    display: block;
	pointer-events: none;
	z-index: 1;
	position: relative;
	border-bottom-left-radius: 8px;
	border-top-left-radius: 8px;
}

.input-icon-box-icon {
	color: $black;
	font-size: 14px;
	height: 20px;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	position: absolute;
}
</style>
